/**
 * 减法运算，避免数据相减小数点后产生多位数和计算精度损失。
 *
 */
export function numSub(num1: any, num2: any) {
  let baseNum, baseNum1, baseNum2
  let precision // 精度
  try {
    baseNum1 = num1.toString().split('.')[1].length
  } catch (e) {
    baseNum1 = 0
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length
  } catch (e) {
    baseNum2 = 0
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
  precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2
  return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision)
}

/**
 *参数：arg1：第一个加数；arg2第二个加数；d要保留的小数位数（可以不传此参数，如果不传则不处理小数位数）
 *
 */
export function numAdd(num1: any, num2: any) {
  let arg1 = num1.toString()
  let arg2 = num2.toString()
  let arg1Arr = arg1.split('.'),
    arg2Arr = arg2.split('.'),
    d1 = arg1Arr.length === 2 ? arg1Arr[1] : '',
    d2 = arg2Arr.length === 2 ? arg2Arr[1] : ''
  let maxLen = Math.max(d1.length, d2.length)
  let m = Math.pow(10, maxLen)
  let result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen))
  let d = arguments[2]
  return typeof d === 'number' ? Number(result.toFixed(d)) : result
}
/**
   参数：arg1：第一个乘数；arg2第二个乘数；d要保留的小数位数（可以不传此参数，如果不传则不处理小数位数)
 * 
 */
export function numMulti(arg1: any, arg2: any) {
  let r1 = arg1.toString()
  let r2 = arg2.toString()
  let m
  let resultVal
  let d = arguments[2]
  m =
    (r1.split('.')[1] ? r1.split('.')[1].length : 0) +
    (r2.split('.')[1] ? r2.split('.')[1].length : 0)
  resultVal =
    (Number(r1.replace('.', '')) * Number(r2.replace('.', ''))) /
    Math.pow(10, m)
  return typeof d !== 'number'
    ? Number(resultVal)
    : Number(resultVal.toFixed(parseInt(d + '')))
}
//2.强制保留2位小数，如：2，会在2后面补上00.即2.00
export function toDecimal2(x: any): any {
  let f = parseFloat(x)
  if (isNaN(f)) {
    return false
  }
  f = Math.round(x * 100) / 100
  let s = f.toString()
  let rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}

export function phonePlatform(): string {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS) {
    return 'iOS'
  } else if (isAndroid) {
    return 'Android'
  }
  return ''
}

export function getUrlQueryDic(str: string) {
  var url = str ? str : decodeURI(window.location.search); //获取url中"?"符后的字串
  var theRequest: any = {};
  if (url.indexOf('?') !== -1) {
    url = url.split('?')[1]
  }
  if (url) {
      var strs = url.split('&');
      for (var i = 0; i < strs.length; i++) {
          var srtArry = strs[i].split('=');
          if (srtArry.length >= 2) {
            const k = srtArry[0]
            const v = srtArry[1]
            theRequest[k] = v
          }
      }
  }
  return theRequest;
}